import { NUM_PLAYERS_CHANGED } from './actions'

export const numPlayers = (state = 0, action) => {
    switch (action.type) {
        case NUM_PLAYERS_CHANGED:
            return action.numPlayers

        default:
            return state
    }
}

export const onlinePlayers = (state = 0, action) => {
    switch (action.type) {
        case NUM_PLAYERS_CHANGED:
            return action.onlinePlayers

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/numPlayers/index.js